//@vendors
const Immutable = require('immutable');
const { handleActions } = require('redux-actions');
//@actions
const { simpleActions } = require('../../actions/contractAresLoan');

const setInitialState = () => Immutable.fromJS({
    success: false,
    isFetching: true,
    error: false,
    documents: null,
    policyLink: null,
    INELink: null,
});

const contractAresLoanReducer = handleActions(
    {
        [simpleActions.contractAresLoanStatus]: state =>
            state.merge({
                isFetching: true,
                success: false,
                error: false,
            }),
        [simpleActions.contractAresLoanHiringDocumentsSuccess]: (state, action) =>
            state.merge({
                documents: action.payload.response,
                isFetching: false,
                success: true,
                error: false,
            }),
        [simpleActions.contractAresLoanPolicySuccess]: (state, action) =>
            state.merge({
                policyLink: action.payload.response,
                isFetching: false,
                success: true,
                error: false,
            }),
        [simpleActions.contractAresLoanIneSuccess]: (state, action) =>
            state.merge({
                INELink: action.payload.response,
                isFetching: false,
                success: true,
                error: false,
            }),
        [simpleActions.contractAresLoanError]: (state, action) =>
            state.merge({
                isFetching: false,
                success: false,
                error: action.payload.error,
            })
    },
    setInitialState()
);

module.exports = contractAresLoanReducer;
module.exports.setInitialState = setInitialState;
